module.exports = __webpack_public_path__ + "img/pic2_m.fecd228d.jpg";